
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
}

export default function SEOHead({ title, description, keywords }: SEOHeadProps) {
  const location = useLocation();
  const baseUrl = 'https://hund-im-alter.de';
  const canonicalUrl = `${baseUrl}${location.pathname}`;

  useEffect(() => {
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (canonicalLink) {
      canonicalLink.href = canonicalUrl;
    } else {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      canonicalLink.href = canonicalUrl;
      document.head.appendChild(canonicalLink);
    }

    // Update Open Graph URL
    let ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
    if (ogUrl) {
      ogUrl.content = canonicalUrl;
    }

    // Update title if provided
    if (title) {
      document.title = title;
      const ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement;
      if (ogTitle) ogTitle.content = title;
      const twitterTitle = document.querySelector('meta[name="twitter:title"]') as HTMLMetaElement;
      if (twitterTitle) twitterTitle.content = title;
    }

    // Update description if provided
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
      if (metaDesc) metaDesc.content = description;
      const ogDesc = document.querySelector('meta[property="og:description"]') as HTMLMetaElement;
      if (ogDesc) ogDesc.content = description;
      const twitterDesc = document.querySelector('meta[name="twitter:description"]') as HTMLMetaElement;
      if (twitterDesc) twitterDesc.content = description;
    }

    // Update keywords if provided
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]') as HTMLMetaElement;
      if (metaKeywords) {
        metaKeywords.content = keywords;
      }
    }

    // Update last-modified
    const lastModified = document.querySelector('meta[name="last-modified"]') as HTMLMetaElement;
    if (lastModified) {
      lastModified.content = new Date().toISOString().split('T')[0];
    }
  }, [canonicalUrl, title, description, keywords]);

  return null;
}
